import { apiBase } from "@superadmin/configs/env.config";
import { createAuthClient } from "better-auth/client";

/**
 * Same better-auth backend as the main app (`/api/auth/*`). The superadmin
 * console has no accounts of its own: anyone can sign in with Google, but
 * only users listed in the backend's SUPER_ADMIN_EMAILS get past `ping`.
 */
export const authClient = createAuthClient({
	baseURL: apiBase || window.location.origin,
});
